import ko from "knockout";
import $ from "jquery";
import myFlowLocator from "flow/utils/myFlowLocator";
import config from "flow/config";
import register from "flow/knockout/register";

register.registerKnockoutBinding("inspector", {
    init: function (element, valueAccessor, _allBindingsAccessor, viewModel) {
        $(element).on("click", function () {
            const myFlow = myFlowLocator.getMyFlow(viewModel);
            myFlow.showCustomDialog(config.componentIds.inspector, {
                myFlow: myFlow,
                viewModel: ko.unwrap(valueAccessor())
            });
        });
    }
});
